const EmployeeRoutes = [
  {
    path: "/employees",
    name: "Employees",
    component: () => import("@/pages/employees/EmployeeListPage.vue"),
    meta: {
      auth: true,
      permission: {
        act: 'read', on: 'Employee'
      }
    },
    children: [
      {
        path: "new_employee",
        name: "NewEmployee",
        component: () => import("@/pages/employees/NewEmployeePage.vue"),
        meta: {
          auth: true,
          permission: {
            act: 'create', on: 'Employee'
          }
        },
      },
      {
        path: ":id",
        name: "ShowEmployee",
        component: () => import("@/pages/employees/ShowEmployeePage.vue"),
        meta: {
          auth: true,
          permission: {
            act: 'read', on: 'Employee'
          }
        },
      }
    ]
  },
]

export default EmployeeRoutes